import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import HomePage from "@/pages/HomePage";
import BookingPage from "@/pages/BookingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ContactPage from "@/pages/ContactPage";
import ContractPage from "@/pages/ContractPage";
import ConditionReportPage from "@/pages/ConditionReportPage";
import DestinationPage from "@/pages/DestinationPage";
import LegalPage from "@/pages/LegalPage";

function App() {
  useEffect(() => {
    const seedDatabase = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/seed`, {
          method: 'POST'
        });
        const data = await response.json();
        console.log('Database seed:', data.message);
      } catch (e) {
        console.log('Seed request:', e.message);
      }
    };
    seedDatabase();
  }, []);

  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-[#FDFBF7] overflow-x-hidden">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/reservation" element={<BookingPage />} />
            <Route path="/reservation/:boatId" element={<BookingPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/contrat/:bookingId" element={<ContractPage />} />
            <Route path="/etat-des-lieux/:bookingId" element={<ConditionReportPage />} />
            {/* Destination pages (SEO) */}
            <Route path="/location-bateau-sans-permis-punta-di-spanu" element={<DestinationPage />} />
            <Route path="/location-bateau-sans-permis-plage-aregno" element={<DestinationPage />} />
            <Route path="/location-bateau-sans-permis-plage-de-davia" element={<DestinationPage />} />
            <Route path="/location-bateau-sans-permis-plage-de-pain-de-sucre" element={<DestinationPage />} />
            <Route path="/location-bateau-sans-permis-plage-arinella" element={<DestinationPage />} />
            <Route path="/location-bateau-sans-permis-calvi" element={<DestinationPage />} />
            <Route path="/location-bateau-sans-permis-lumio" element={<DestinationPage />} />
            <Route path="/location-bateau-sans-permis-balagne" element={<DestinationPage />} />
            <Route path="/location-bateau-sans-permis-ile-rousse" element={<DestinationPage />} />
            <Route path="/cgv" element={<LegalPage />} />
            <Route path="/politique-confidentialite" element={<LegalPage />} />
            <Route path="/mentions-legales" element={<LegalPage />} />
            {/* Old Wix URL redirections */}
            <Route path="/book-online" element={<Navigate to="/reservation" replace />} />
            <Route path="/book-online/*" element={<Navigate to="/reservation" replace />} />
            <Route path="/service-page" element={<Navigate to="/reservation" replace />} />
            <Route path="/service-page/*" element={<Navigate to="/reservation" replace />} />
            <Route path="/blank" element={<Navigate to="/reservation" replace />} />
            <Route path="/blank/*" element={<Navigate to="/reservation" replace />} />
            <Route path="/product-page" element={<Navigate to="/reservation" replace />} />
            <Route path="/product-page/*" element={<Navigate to="/reservation" replace />} />
            <Route path="/planning-disponibilite" element={<Navigate to="/reservation" replace />} />
            <Route path="/planning-disponibilite/*" element={<Navigate to="/reservation" replace />} />
            <Route path="/planning-disponibilites" element={<Navigate to="/reservation" replace />} />
            <Route path="/itineraires-et-consommation" element={<Navigate to="/" replace />} />
            <Route path="/itineraires-et-consommation/*" element={<Navigate to="/" replace />} />
            <Route path="/itineraires-et-consommations" element={<Navigate to="/" replace />} />
            <Route path="/accessible-site" element={<Navigate to="/" replace />} />
            {/* Catch-all: redirect unknown pages to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
